











import { Component, Vue, Prop } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";

@Component({
  components: {
    Loading,
  },
})
export default class SelectSecao extends Vue {
  @Prop({ default: null }) value!: string;
  @Prop() label!: string;
  @Prop() rules!: any;

  tipos: { key: number; value: string }[] = [
    {
      key: 1,
      value: "Seção 1",
    },
    {
      key: 2,
      value: "Seção 2",
    },
  ];

  emitirInput(val: number) {
    this.$emit("input", val);
  }
}
